module.exports = __webpack_public_path__ + "media/images/patient-checkin-nav-85bed66c38dc630265043abbc6052902.svg";